<script setup lang="ts">
import { ChevronLeft } from '@lucide/vue';

import { Button } from '@/components/lib/shadcn-vue/button';
import type { WithClassAsProps } from '@/components/lib/shadcn-vue/carousel/interface';
import { cn } from '@/components/lib/shadcn-vue/utils';

interface Props {
  orientation?: 'horizontal' | 'vertical';
  shouldDisplayByDefault?: boolean;
  canScrollPrev: boolean;
  onClickScrollPrev: (e: MouseEvent) => void;
}

const props = defineProps<WithClassAsProps & Props>();
</script>

<template>
  <Button
    v-if="canScrollPrev"
    variant="carousel"
    :class="
      cn(
        'absolute h-8 w-8 touch-manipulation rounded-full p-0',
        shouldDisplayByDefault ? 'md:block' : 'md:hidden md:group-hover:block',
        orientation === 'horizontal' ? 'left-1 top-1/2 -translate-y-1/2' : '-top-12 left-1/2 -translate-x-1/2 rotate-90',
        props.class,
      )
    "
    :disabled="!canScrollPrev"
    @click="props.onClickScrollPrev"
  >
    <slot>
      <ChevronLeft class="mx-auto h-4 w-4 text-current text-light-fg-inverse" />
    </slot>
  </Button>
</template>
